<template>
	<div class="form attachmentlist__filters">
		<div class="grid">
			<div class="col-12 attachmentlist__filter-col">
				<div role="search" class="form-search">
					<label for="attachment-search-form-input">
						{{ translations.searchLabel }}
					</label>
					<button
						type="submit"
						:title="translations.searchLabel"
						:aria-label="translations.searchLabel"
					>
						<div class="icon icon-magnifier">
							<svg
								data-name="Layer 1"
								version="1.1"
								width="20px"
								height="24px"
								viewBox="0 0 23.73 23.73"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="m23.73 22.31-5.63-5.62a10.21 10.21 0 1 0-1.41 1.41l5.62 5.63zm-13.51-3.89a8.2 8.2 0 1 1 8.2-8.2 8.21 8.21 0 0 1-8.2 8.2z"
								></path>
							</svg>
						</div>
					</button>
					<input
						class="attachmentlist__filters-search-input"
						name="searchrequest"
						id="attachment-search-form-input"
						type="search"
						:placeholder="translations.searchPlaceholder"
						:title="translations.searchLabel"
						autocomplete="off"
						aria-autocomplete="list"
						aria-haspopup="true"
						:aria-label="translations.searchLabel"
						v-model="value.searchTerm"
						@input="updateSearch"
					/>
				</div>
			</div>
			<div
				class="col-12_smx-12_md-4 col__subjects attachmentlist__filter-col"
			>
				<Dropdown>
					<template #btn
						><div
							class="bp-dropdown__btn-text"
							id="subject-placeholder"
							aria-labelledby="subject-placeholder"
						>
							{{ translations.subjectsDropdownPlaceholder }}
						</div>
					</template>
					<template #body>
						<ul
							class="ul--nostyling js-dropdown-listbox"
							id="subject-element-list"
							tabindex="0"
							aria-labelledby="subject-placeholder"
							role="listbox"
							aria-multiselectable="true"
						>
							<li
								role="option"
								v-for="(subject, index) in availableSubjects"
								:key="subject"
								aria-selected="false"
								:id="'subject-' + index"
								:aria-label="
									subject +
									' ' +
									translations.xofy
										.replace('X', index + 1)
										.replace('Y', availableSubjects.length)
								"
							>
								<label class="checkbox">
									<input
										type="checkbox"
										:value="subject"
										v-model="value.subjects"
										@change="updateSubjects"
										:aria-labelledby="'subject-' + index"
									/>
									<span class="checkbox__checkmark"></span>
									{{ subject }}
								</label>
							</li>
						</ul>
					</template>
				</Dropdown>
			</div>
			<div
				class="col-12_smx-6_md-3 col__datepicker attachmentlist__filter-col"
			>
				<Datepicker
					id="fromDate"
					name="fromDate"
					label="Fra"
					:value="value.fromDate"
					@update="updateFromDate"
					:defaultDate="fromDateDefault"
					:ariaLabel="ariaLabelChooseFromDate"
				></Datepicker>
			</div>
			<div
				class="col-12_smx-6_md-3 col__datepicker attachmentlist__filter-col"
			>
				<Datepicker
					id="toDate"
					name="toDate"
					label="Til"
					:value="value.toDate"
					@update="updateToDate"
					:defaultDate="toDateDefault"
					:ariaLabel="ariaLabelChooseToDate"
				></Datepicker>
			</div>
			<div
				class="col-12_smx-12_md-2 col__submit-button attachmentlist__filter-col"
			>
				<button
					class="button button--leaf attachmentlist__search-btn"
					@click="update"
				>
					{{ translations.searchPlaceholder }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { toRefs } from "vue";
import Dropdown from "./../../../shared/script/vue/Dropdown.vue";
import Datepicker from "./../../datepicker/datepicker.vue";

const props = defineProps({
	availableSubjects: { type: Array, default: () => [] },
	value: { type: Object },
	translations: { type: Object },
	toDateDefault: { type: String },
	fromDateDefault: { type: String },
	ariaLabelChooseFromDate: { type: String, default: "Vælg fra dato" },
	ariaLabelChooseToDate: { type: String, default: "Vælg til dato" },
	ariaLabelChooseSubject: { type: String, default: "Vælg emne" },
});

const {
	availableSubjects,
	value,
	translations,
	toDateDefault,
	fromDateDefault,
	ariaLabelChooseFromDate,
	ariaLabelChooseToDate,
} = toRefs(props);

const emit = defineEmits(["update"]);

const updateFromDate = (date) => {
	value.value.fromDate = date;
	emit("update", value.value);
};

const updateToDate = (date) => {
	value.value.toDate = date;
	emit("update", value.value);
};

const updateAriaSelected = (e) => {
	const optionEL = e.target.parentElement.parentElement;
	optionEL.setAttribute("aria-selected", e.target.checked);
};

const updateSearch = (e) => {
	if (e.target) {
		updateAriaSelected(e);
		value.value.searchTerm = e.target.value;
		emit("update", value.value);
	}
};

const updateSubjects = (e) => {
	const selectedSubjects = Array.from(
		e.target.parentElement.parentElement.querySelectorAll("input:checked")
	).map((el) => el.value);
	value.value.subjects = selectedSubjects;
	emit("update", value.value);
};
</script>
